import getChartData from "@/api/dashboard";
import { DASHBOARD_CHART_DEFINITION } from "@/misc/desktopCharts";

const state = {
  chartData: {},
  currentPage: "",
  dashBoardSelectedDate: null,
};

const getters = {
  currentCharts: (state) => state.chartData,
  currentPage: (state) => state.currentPage,
  dashBoardSelectedDate: (state) => state.dashBoardSelectedDate,
};

const actions = {
  async fetchCurrentChartData({ commit, getters, rootGetters }, chartName) {
    const targetDate = getters.dashBoardSelectedDate;
    const currentStore = rootGetters["user/getCurrentStore"];
    const filters = rootGetters["filters/getAllActiveFilters"];
    commit("setLoading", chartName);
    try {
      let chartData = await getChartData(chartName, targetDate, currentStore.store_id, filters);
      commit("setChartData", { chartName, chartData, targetDate });
    } catch (e) {
      commit("setChartError", chartName);
    }
  },
  setCurrentChartData({ dispatch, getters }) {
    if (!getters.dashBoardSelectedDate) return;

    DASHBOARD_CHART_DEFINITION.forEach((chart) => {
      dispatch("fetchCurrentChartData", chart.name);
    });
  },
  resetAllCharts({ commit, dispatch }) {
    DASHBOARD_CHART_DEFINITION.forEach((chart) => {
      commit("resetChartData", chart.name);
    });
    dispatch("setCurrentChartData");
  },
  setDashboardDate({ dispatch, commit }, date) {
    commit("setSelectedDashboardDate", date);
    dispatch("setCurrentChartData");
  },
  setCurrentPage({ commit, dispatch }, page) {
    commit("setPage", page);
    if (page === "dashboard") {
      dispatch("resetAllCharts");
    }
  },
};

const mutations = {
  setPage(state, currentPage) {
    state.currentPage = currentPage;
  },
  resetChartData(state, chartName) {
    state.chartData[chartName] = {};
  },
  setLoading(state, chartName) {
    state.chartData = {
      ...state.chartData,
      [chartName]: { isLoading: true },
    };
  },
  setChartError(state, chartName) {
    state.chartData = {
      ...state.chartData,
      [chartName]: { isError: true },
    };
  },
  setChartData(state, payload) {
    let { chartName, chartData, targetDate } = payload;
    state.chartData = {
      ...state.chartData,
      [chartName]: {
        dates: targetDate,
        ...chartData,
      },
    };
  },
  setSelectedDashboardDate(state, date) {
    state.dashBoardSelectedDate = date;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
